import React from 'react'
import {ServerConfig} from 'config'

import PaginatedList from '../../components/PaginatedList/PaginatedList'


const Tenants = () => {
  const editable_fields = [
    ["password", "Password"],
    ["first_name", "First name"],
    ["last_name", "Last name"],
    ["business_name", "Business name"],
    ["business_tagline", "Business tagline"],
    ["business_logo_b64", "Logo", "b64image"],
    ["shortcode", "Shortcode"],
    ["email", "Email"],
    //["paypal_email", "Paypal Email"],
    ["phone_number", "Phone number"],
    ["street", "Street"],
    //["housenumber", "Housenumber"],
    ["zipcode", "Zipcode"],
    ["city", "City"],
    ["state", "State"],
      ["paypal_acct_client_id", "Paypal Client ID"],
      ["paypal_acct_client_secret", "Paypal Secret"],
      ["checkbook_api_key", "Checkbook API key"],
      ["checkbook_api_secret", "Checkbook Secret"],
      ["onbe_program_id", "EcoCard (Onbe) Program ID"],
      ["onbe_promotion_id", "EcoCard (Onbe) Promotion ID"],
      ["onbe_access_level", "EcoCard (Onbe) Access Level"],
      ["parent_tenant_id", "Parent Tenant (sub-account of)", "tenant_optional"]
  ];

  const non_editable_fields = [
    ["sub_accounts", "Sub-accounts", "subaccountlist"]
  ];

	return (
		<>
		    <PaginatedList
          list_get_url = {`${ServerConfig.SERVER_URL}/admin/tenant/`}
          detail_get_url = {`${ServerConfig.SERVER_URL}/tenant/`}
          detail_put_url = {`${ServerConfig.SERVER_URL}/tenant/`}
          add_new_url={`${ServerConfig.SERVER_URL}/tenant/`}

          column_names = {["balance_dollars", "business_name", "shortcode",  "edit"]}
          header_names = {["Balance", "Business Name", "Shortcode", ""]}

          optional_column_names={["zipcode", "city", "street", "email", "phone_number"]}
          optional_header_names={["Zip", "City", "Street", "Email", "Phone"]}

          editable_fields = {editable_fields}
          non_editable_fields = {non_editable_fields}

          ledger_get_url = '/ledger/tenant/'  // the endpoints of the detail-view are NOT adapted for tenants yet!
          ledger_insert_url='/ledger/insert_tenant/'
          ledger_allow_entries = {true}
        />
		</>
		)
}

export default Tenants
